import "./HomePage.scss"
import Alpha from "./Alpha/Alpha"
import MyPortfolio from "../../components/MyPortfolio/MyPortfolio"
import MyStack from "./MyStack/MyStack"
import MyContact from "./MyContact/MyContact"
import GoogleMap from "../../components/GoogleMap/GoogleMap"
import FadeIn from "../../components/FadeIn/FadeIn"

const Section = ({ children }) => {
    const [ref, isVisible] = FadeIn(0.2)
  
    return (
      <section ref={ref} className={`fade-in-section ${isVisible ? "visible" : ""}`}>
        {children}
      </section>
    )
  }

const HomePage = ({ setOpenModal, portfolioData }) => {
    return(
    <main>
    <Section> <Alpha setOpenModal={setOpenModal} /> </Section>
    <Section> <MyPortfolio portfolioData={portfolioData} cardsToWatch={3} /> </Section>
    <Section> <MyStack /> </Section>
    <Section> <MyContact /> </Section>
    <Section> <GoogleMap /> </Section>
    </main>      
    )
} 
export default HomePage

